import { Modal } from "components/modal";
import { CreateInvoicePayload } from "modules/invoice/types/invoice.interface";
import { FunctionComponent, useState } from "react";

interface AcompteModalProps {
  setAcomptePercent: (isAcompte: number) => void;
  setShowAcompteModal: (showAcompteModal: boolean) => void;
  setFormValues: (formValues: CreateInvoicePayload) => void;
  formValues: CreateInvoicePayload;
}

export const AcompteModal: FunctionComponent<AcompteModalProps> = ({
  setAcomptePercent,
  setShowAcompteModal,
  setFormValues,
  formValues,
}) => {
  const [step, setStep] = useState<"ask" | "percent">("ask");
  const [percent, setPercent] = useState(0);

  const handleSubmit = () => {
    if (percent > 0) {
      console.log(formValues);
      setFormValues({
        ...formValues,
        totalTTC: formValues.totalTTC * (percent / 100),
        totalHT: formValues.totalHT * (percent / 100),
        lineItems: [
          {
            quantity: 1,
            totalTTC: formValues.totalTTC * (percent / 100),
            totalHT: formValues.totalHT * (percent / 100),
            vatAmount: 20,
            reductionAmount: 0,
            priceHT: formValues.totalHT * (percent / 100),
            description: `Acompte de ${percent}% pour le devis ${formValues.devisDocumentNumber}`,
          },
        ],
      });
    }
  };

  if (step === "ask") {
    return (
      <Modal>
        <div className="space-y-4 p-4">
          <h3 className="text-lg font-semibold">Type de facture</h3>
          <p className="text-gray-600">S'agit-il d'une facture d'acompte ?</p>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={() => {
                setAcomptePercent(0);
                setShowAcompteModal(false);
              }}
              className="rounded-lg border border-gray-300 px-4 py-2 hover:bg-gray-50"
            >
              Non
            </button>
            <button
              type="button"
              onClick={() => setStep("percent")}
              className="rounded-lg bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
            >
              Oui
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal>
      <div className="space-y-4 p-4">
        <h3 className="text-lg font-semibold">Pourcentage d'acompte</h3>
        <p className="text-gray-600">Quel est le pourcentage d'acompte ?</p>
        <input
          type="number"
          min="0"
          max="100"
          value={percent}
          onChange={(e) =>
            setPercent(
              Math.min(100, Math.max(0, parseInt(e.target.value) || 0))
            )
          }
          className="w-full rounded-lg border border-gray-300 px-4 py-2"
        />
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={() => setStep("ask")}
            className="rounded-lg border border-gray-300 px-4 py-2 hover:bg-gray-50"
          >
            Retour
          </button>
          <button
            type="button"
            onClick={() => {
              setAcomptePercent(percent);
              setShowAcompteModal(false);
              handleSubmit();
            }}
            className="rounded-lg bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
          >
            Valider
          </button>
        </div>
      </div>
    </Modal>
  );
};
